import React, { Fragment, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";

import { useAuth } from "../../../context/AuthContext";
import { db, storage } from "../../../firebase";
import {
  setDoc,
  updateDoc,
  doc,
  collection,
  query,
  orderBy,
  getDoc,
} from "firebase/firestore";
import { ref, uploadBytes, deleteObject, listAll } from "firebase/storage";
import { notifyTopRight, notifyWarning, notifyError } from "../toast/SetToast";
import Toast from "../toast/SetToast";
import { TicketForm } from "./TicketForm";
import { useCollection } from "../../../hook/useCollection";

const TicketCreate = (props) => {
  const { currentUser } = useAuth();
  const [fileNames, setFilenames] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selected, setSelected] = useState(null);
  const [serviceOrderNumber, setServiceOrderNumber] = useState(null);
  // Add state for the fields that get populated by search
  const [patientData, setPatientData] = useState({
    firstname: "",
    lastname: "",
    refCustomer: "",
    mobile: "",
    nodeRef: "",
    warranty: "",
    hn: "",
    brand: "",
    model: "",
    purchaseDate: "",
  });

  const inputRef = useRef({
    date: "",
    serviceType: "",
    sn: "",
    detail: "",
    accessories: "",
    description: "",
    image: "",
    receiveBy: "",
    serviceStatus: "",
    repairLocation: "",
    externalRepairSentDate: "",
    serviceDetail: "",
    amount: "",
    completionDate: "",
    serviceBy: "",
    createdBy: "",
    note: "",
  });

  const { documents, error } = useCollection("products", [
    "serialNumber",
    "asc",
  ]);

  const handleChange = (name) => (e) => {
    if (name === "image") {
      for (let i = 0; i < e.target.files.length; i++) {
        const f = e.target.files[i];
        setSelectedFiles((prevState) => [...prevState, f]);
        setFilenames((prevState) => [...prevState, f.name]);
        console.log(f.name);
      }
    } else if (name === "sn") {
      setSelected(e.target.value);
      inputRef.current[name] = e.target.value;
      console.log("inputRef.current", inputRef.current["sn"]);
    } else {
      inputRef.current[name] = e.target.value;
    }
  };

  const handleProductFound = (productData) => {
    console.log("productData", productData);

    setPatientData((prev) => ({
      ...prev,
      firstname: productData.firstname || "",
      lastname: productData.lastname || "",
      refCustomer: productData.refCustomer || "",
      mobile: productData.mobile || "",
      nodeRef: productData.nodeRef || "",
      warranty: productData.warranty || "",
      hn: productData.hn || "",
      brand: productData.brand || "",
      model: productData.model || "",
      purchaseDate: productData.purchaseDate || "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      ...patientData,
      serviceOrderNumber: serviceOrderNumber,
      date: inputRef.current.date,
      purchaseDate: patientData.purchaseDate ? new Date(patientData.purchaseDate) : null,
      warranty: patientData.warranty ? new Date(patientData.warranty) : null,
      serviceType: inputRef.current.serviceType,
      sn: inputRef.current.sn,
      detail: inputRef.current.detail,
      accessories: inputRef.current.accessories,
      description: inputRef.current.description,
      image: fileNames,
      receiveBy: inputRef.current.receiveBy,
      serviceStatus: inputRef.current.serviceStatus,
      repairLocation: inputRef.current.repairLocation,
      serviceDetail: inputRef.current.serviceDetail,
      completionDate: inputRef.current.completionDate,
      serviceBy: inputRef.current.serviceBy,
      externalRepairSentDate: inputRef.current.externalRepairSentDate || "",
      amount: inputRef.current.amount || "",
      note: inputRef.current.note || "",
      createdBy: currentUser.displayName,
      updatedAt: new Date(),
      createdAt: new Date(),
    };

    const docRef = doc(collection(db, "serviceTickets"));

    console.log("formData", data);

    await setDoc(docRef, data).then(async () => {
      await updateDoc(doc(db, "serviceTickets", docRef.id), {
        ticketId: docRef.id,
      });

      // Create logs for service tickets (similar to order logs)
      const loggingPromises = [];

      // Only create logs if we have the necessary data (HN and Serial Number)
      if (patientData.hn && inputRef.current.sn) {
        // Find the product to get its ID
        const product = documents.find(
          (doc) => doc.serialNumber === inputRef.current.sn
        );

        if (product) {
          // Create patient service log in patients/{hn}/services/{ticketId}
          const patientServiceLog = {
            ticketId: docRef.id,
            serviceOrderNumber: serviceOrderNumber,
            productId: product.id,
            productSn: inputRef.current.sn,
            activity: "service",
            serviceType: inputRef.current.serviceType,
            serviceStatus: inputRef.current.serviceStatus,
            createdAt: new Date(),
            createdBy: currentUser.displayName,
          };

          loggingPromises.push(
            setDoc(
              doc(db, "patients", patientData.hn, "orders", docRef.id),
              patientServiceLog
            )
          );

          // Create product service log in products/{productId}/logs/{ticketId}
          const productServiceLog = {
            hn: patientData.hn,
            firstname: patientData.firstname,
            lastname: patientData.lastname,
            ticketId: docRef.id,
            serviceOrderNumber: serviceOrderNumber,
            productId: product.id,
            productSn: inputRef.current.sn,
            activity: "service",
            serviceType: inputRef.current.serviceType,
            serviceStatus: inputRef.current.serviceStatus,
            createdAt: new Date(),
            createdBy: currentUser.displayName,
          };

          loggingPromises.push(
            setDoc(
              doc(db, "products", product.id, "logs", docRef.id),
              productServiceLog
            )
          );
        }
      }

      // Execute logging operations
      if (loggingPromises.length > 0) {
        await Promise.all(loggingPromises).catch((error) => {
          console.warn("Some service logging operations failed:", error);
        });
      }

      //upload image
      const promises = [];
      selectedFiles.map((file) => {
        const storageRef = ref(
          storage,
          `serviceImage/${docRef.id}/${file.name}`
        );
        const uploadTask = uploadBytes(storageRef, file);
        promises.push(uploadTask);
      });
      Promise.all(promises);
      notifyTopRight("Create success ");
    });

    inputRef.current.date = "";
    inputRef.current.sn = "";
    inputRef.current.ticketType = "";
    inputRef.current.detail = "";
    inputRef.current.accessories = "";
    inputRef.current.description = "";
    inputRef.current.image = "";
    inputRef.current.receiveBy = "";
    inputRef.current.serviceStatus = "";
    inputRef.current.repairLocation = "";
    inputRef.current.serviceDetail = "";
    inputRef.current.completionDate = "";
    inputRef.current.serviceBy = "";
    inputRef.current.createdBy = "";
    inputRef.current.requestDate = "";
    inputRef.current.dueDate = "";

    // Reset form
    setServiceOrderNumber(null);
    setSelectedFiles([]);
    setFilenames([]);
    setPatientData({
      firstname: "",
      lastname: "",
      refCustomer: "",
      mobile: "",
      nodeRef: "",
      warranty: "",
      hn: "",
      brand: "",
      model: "",
      purchaseDate: "",
    });

    // update next service order number
    const { sequence } = await getNextSequence();
    const newSequence = parseInt(sequence, 10) + 1;
    await updateSequence(newSequence);

    e.target.reset();
  };

  async function getNextSequence() {
    const sequenceRef = doc(db, "sequenceTracker", "serviceSequence");
    const currentDate = new Date();
    const thaiYear = currentDate.getFullYear() + 543;

    try {
      const sequenceDoc = await getDoc(sequenceRef);

      if (!sequenceDoc.exists()) {
        await setDoc(sequenceRef, { current: 1, year: thaiYear });
        return { sequence: "001", year: thaiYear };
      }

      const data = sequenceDoc.data();
      let currentSequence;

      // Reset sequence to 1 if year changed
      if (data.year !== thaiYear) {
        currentSequence = 1;
        await setDoc(sequenceRef, { current: 1, year: thaiYear });
      } else {
        currentSequence = data.current;
      }

      return { sequence: currentSequence.toString().padStart(3, "0"), year: thaiYear };
    } catch (e) {
      console.error("Failed to get sequence: ", e);
      throw e;
    }
  }

  async function updateSequence(newSequence) {
    const sequenceRef = doc(db, "sequenceTracker", "serviceSequence");
    const currentDate = new Date();
    const thaiYear = currentDate.getFullYear() + 543;

    try {
      await updateDoc(sequenceRef, { current: newSequence, year: thaiYear });
    } catch (e) {
      console.error("Failed to update sequence: ", e);
      throw e;
    }
  }

  const generateId = async () => {
    const { sequence, year } = await getNextSequence();
    const yearStr = year.toString().slice(2);
    return `SV${yearStr}${sequence}`;
  };

  useEffect(() => {
    // Generate the service order number when the component mounts
    generateId().then((id) => setServiceOrderNumber(id));
  }, []);

  return (
    <Fragment>
      <PageTitle
        activeMenu="Create Service Ticket"
        motherMenu="Ticket"
        motherLink="/service-ticket-create"
      />
      <Toast />
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Create Service Ticket</h4>
            </div>

            <div className="card-body">
              <div className="form-validation">
                <form
                  className="form-valide"
                  action="#"
                  method="post"
                  onSubmit={handleSubmit}
                >
                  <div className="row">
                    <div className="col-xl-6">
                      <TicketForm
                        onChange={handleChange}
                        fileNames={fileNames}
                        initailValues={null}
                        product={selected}
                        defaultfiles={[]}
                        patientData={patientData}
                        onProductFound={handleProductFound}
                        serviceOrderNumber={serviceOrderNumber}
                      />
                      <br /> <br />
                      <div className="form-group row">
                        <div className="col-lg-8 ml-auto">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TicketCreate;
